<template>
	<div id="app">
		<ShareModal ref="shareModal" />
		<router-view />
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {

		};
	},
  metaInfo() {
    const siteName = '好事道'; // 您的網站名稱
    // 確保 defaultFallbackOgImage 是一個有效的、公開可訪問的圖片URL
    const defaultFallbackOgImage = 'https://gddao.com/logo.png'; // 或者一個更全域的預設分享圖

    return {
      // 全站的標題模板
      // 每個頁面組件中的 title 將會替換 '%s'
      // 例如，如果頁面 title 是 "捐款項目"，最終標題會是 "捐款項目 | 好事道"
      titleTemplate: `%s | ${siteName}`,
      meta: [
        // 全站通用的 Open Graph 網站名稱
        { vmid: 'og:site_name', property: 'og:site_name', content: siteName },
        // 提供一個全站最終的 fallback OG image
        // 如果頁面組件及其自身的 fallback 都沒有提供 og:image，則會使用這個
        { vmid: 'og:image:fallback', property: 'og:image', content: defaultFallbackOgImage },
        // 可選：為這個 fallback 圖片提供尺寸
        { vmid: 'og:image:width:fallback', property: 'og:image:width', content: '200' }, // 假設 logo.png 尺寸
        { vmid: 'og:image:height:fallback', property: 'og:image:height', content: '200' },// 假設 logo.png 尺寸
        // 您可以在此添加其他希望全站生效的預設 meta 標籤
        // 例如，如果您的網站在特定地區運營
        // { vmid: 'og:locale', property: 'og:locale', content: 'zh_TW' },
      ]
    };
	}
};
</script>
<style lang="scss" scoped>
@import url("app.css");

@import url("imapp.css");
</style>
<style>
/* 全局滚动条样式配置 */
::-webkit-scrollbar {
	width: 6px;
	height: 6px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb {
	background-color: #a7a7a7;
	border-radius: 4px;
}

::-webkit-scrollbar-track {
	background-color: #F5F5F5;
}

html {
	-webkit-overflow-scrolling: auto !important; /* 禁用弹性滚动 */
	overflow: auto !important;
}

/* 强制所有可滚动容器显示滚动条 */
[class*="scroll"],
[class*="overflow"] {
	-webkit-overflow-scrolling: touch;
	overflow: auto !important;
	scrollbar-width: thin; /* 兼容Firefox */
}
</style>